/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ptl-report-top-actions',
  templateUrl: './report-top-actions.component.html',
  styleUrls: ['./report-top-actions.component.scss'],
})
export class ReportTopActionsComponent {
  @Input() editIsEnabled = true;
  @Input() dragDropIsEnabled = true;

  /** Emits on section edit. */
  @Output() sectionEdit = new EventEmitter<void>();
  /** Emits on section delete. */
  @Output() sectionDelete = new EventEmitter<void>();

  onSectionEdit() {
    this.sectionEdit.emit();
  }

  onSectionDelete() {
    this.sectionDelete.emit();
  }
}
